import React, { useRef, useState } from 'react';
import html2canvas from 'html2canvas';
import { QRCodeCanvas } from 'qrcode.react';
import { Download, Loader2, QrCode } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { joinLink } from './joinConfig';

// Printable A4-ratio poster (595x842) for campuses & rallies
export const QRPoster = ({ refCode }) => {
  const { t } = useLanguage();
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const link = joinLink(refCode);

  const download = async () => {
    setBusy(true);
    try {
      const canvas = await html2canvas(ref.current, { scale: 3, backgroundColor: '#ffffff' });
      const a = document.createElement('a');
      a.download = `NDP_Join_Poster${refCode ? `_${refCode}` : ''}.png`;
      a.href = canvas.toDataURL('image/png');
      a.click();
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <button onClick={download} disabled={busy} className="inline-flex items-center justify-center gap-2 rounded-full border border-gray-300 px-5 py-3 text-sm font-bold text-gray-800 transition-colors duration-200 hover:bg-gray-900 hover:text-white" data-testid="download-qr-poster-btn">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <QrCode className="h-4 w-4" />}
        {t({ en: 'Download QR Poster (print)', bn: 'কিউআর পোস্টার ডাউনলোড (প্রিন্ট)' })}
        <Download className="h-4 w-4" />
      </button>
      <div style={{ position: 'fixed', left: -10000, top: 0 }} aria-hidden>
        <div ref={ref} style={{ width: 595, height: 842, background: '#fff', fontFamily: "'Space Grotesk', sans-serif" }} className="flex flex-col">
          <div style={{ background: '#E30613', height: 18 }} />
          <div style={{ background: '#00A651', height: 10 }} />
          <div className="flex flex-1 flex-col items-center justify-center px-12 text-center">
            <p style={{ fontSize: 14, letterSpacing: 6, color: '#00A651', fontWeight: 700 }}>NATIONAL DEMOCRATIC PARTY</p>
            <p style={{ fontSize: 64, fontWeight: 900, lineHeight: 1, color: '#0B0B0F', marginTop: 18 }}>YOUR VOICE.<br /><span style={{ color: '#E30613' }}>YOUR NDP.</span></p>
            <p style={{ fontSize: 20, color: '#333', marginTop: 18 }}>আজই এনডিপিতে যোগ দিন · Join in 2 minutes</p>
            <div style={{ marginTop: 34, padding: 16, border: '4px solid #0B0B0F', borderRadius: 24 }}>
              <QRCodeCanvas value={link} size={260} />
            </div>
            <p style={{ fontSize: 18, fontWeight: 800, marginTop: 20, color: '#0B0B0F' }}>Scan → Register → Get your digital ID instantly</p>
            <p style={{ fontSize: 14, color: '#666', marginTop: 6 }}>{link.replace(/^https?:\/\//, '')}</p>
          </div>
          <div style={{ background: '#0B0B0F', color: '#fff', padding: 14, textAlign: 'center', fontSize: 13 }}>Member perks · Youth leadership camps · Retail partner discounts (coming soon)</div>
        </div>
      </div>
    </>
  );
};
